import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContainer } from "../ioc/IOCSetup";
import { AppState } from "../RootReducer";
import { getStatusForContent } from "../selectors/content-selectors";
import { fetchContent } from "./ContentfulActions";
import { ContentStatus } from "./ContentfulReducer";
import { ContentModelName } from "./types";



export const GlobalContentComponent = () => {

    const popupContentStatus = useSelector((app : AppState) => getStatusForContent(app, ContentModelName.POPUPMANAGER));

    const dispatch = useDispatch()

    useEffect(() => {
        if (popupContentStatus === ContentStatus.NONE) {
            dispatch(fetchContent(ContentModelName.POPUPMANAGER, getContainer().getSettingsService().getActiveLocale().code) as any)
        }        
    }, [popupContentStatus])

    return <></>
}

